import React from 'react'
import {instance as elementTypeService} from '../../services/ElementTypeService'
import {CanvasEditorForElementsStep} from './CanvasEditorForElementsStep'

export function CanvasEditorSolitarius() {
  return (
    <CanvasEditorForElementsStep
      availableElementTypes={elementTypeService.getSolitariusElementTypes()}
    />
  )
}
